import { render } from "./SystemPermissionsView.vue?vue&type=template&id=e10bd142&scoped=true"
import script from "./SystemPermissionsView.vue?vue&type=script&lang=js"
export * from "./SystemPermissionsView.vue?vue&type=script&lang=js"

import "./SystemPermissionsView.vue?vue&type=style&index=0&id=e10bd142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e10bd142"]])

export default __exports__